import {showNotification} from 'platform/components';
import {Show} from 'platform/foundation';

import {
  useGetHyundaiPromisePlatformQuery,
  useHyundaiPromiseAuthenticateMutation,
} from '@dms/api/sales';
import {AdvertisingPlatformCodeEnum} from '@dms/api/shared';
import {featureFlags} from '@dms/feature-flags';
import i18n from '@dms/i18n';
import {useBranchId} from '@dms/settings/shared';
import {handleApiError} from '@dms/shared';

import {
  PlatformAuthenticationFormHyundaiPromise,
  PlatformAuthenticationFormProps,
} from './components/PlatformAuthenticationFormHyundaiPromise';
import {PlatformPhotoSettings} from './components/PlatformPhotoSettings';
import {PlatformSettingsPromptBridge} from './PlatformSettingsPromptBridge';

export function PlatformSettingsHyundaiPromise() {
  return (
    <>
      <Show whenFeatureEnabled={featureFlags.ADVERTISEMENT_HYUNDAI_PROMISE_PROMPT_BRIDGE}>
        <PlatformSettingsPromptBridge code={AdvertisingPlatformCodeEnum.HYUNDAI_PROMISE} />
      </Show>
      <Show whenFeatureDisabled={featureFlags.ADVERTISEMENT_HYUNDAI_PROMISE_PROMPT_BRIDGE}>
        <PlatformSettingsHyundaiPromiseLegacy />
      </Show>
      <PlatformPhotoSettings platformCode={AdvertisingPlatformCodeEnum.HYUNDAI_PROMISE} />
    </>
  );
}

function PlatformSettingsHyundaiPromiseLegacy() {
  const branchId = useBranchId();
  const params = {branchId};
  const {data, isFetching, isError} = useGetHyundaiPromisePlatformQuery({params});
  const [saveAuthentication] = useHyundaiPromiseAuthenticateMutation();

  const onSubmitCredentials: PlatformAuthenticationFormProps['onSubmit'] = (
    values,
    _setErrors,
    reset
  ) =>
    saveAuthentication({body: values, params})
      .unwrap()
      .then(() => {
        showNotification.success(
          i18n.t('entity.advertisingPlatforms.notifications.credentialsSaved')
        );
        reset(undefined, {keepValues: true});
      })
      .catch(handleApiError);

  return (
    <PlatformAuthenticationFormHyundaiPromise
      values={data?.credentials}
      isFetching={isFetching}
      isError={isError}
      onSubmit={onSubmitCredentials}
    />
  );
}
